import './assets/styles/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SkiAreaPage } from './pages/SkiAreaPage';
import { AllStationsPage } from './pages/AllStationsPage';
import { HomePage } from './pages/HomePage';
import { PrecipitationTablePage } from './pages/PrecipitationTablePage';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <main className="app-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/all" element={<AllStationsPage />} />
            <Route path="/precipitation" element={<PrecipitationTablePage />} />
            <Route path="/:skiArea" element={<SkiAreaPage />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App
